import { render, staticRenderFns } from "./menuSite.vue?vue&type=template&id=09d01afe&scoped=true&"
import script from "./menuSite.vue?vue&type=script&lang=js&"
export * from "./menuSite.vue?vue&type=script&lang=js&"
import style0 from "./menuSite.vue?vue&type=style&index=0&id=09d01afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d01afe",
  null
  
)

export default component.exports